export default {
  install (Vue) {
    Vue.mixin({
      computed: {
        mobile () {
          let value

          value = window.innerWidth > window.innerHeight ? false : value = true

          return value
        }
      }
    })
  }
}
